import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const SupportRoleGuard = ({ children, requiredRole = 'support' }) => {
  const user = useSelector((state) => state.account.user);

  if (!user) {
    return <Redirect to="/sign-in" />;
  }

  const hasAccess =
    user.role === requiredRole ||
    user.role === 'admin' ||
    (requiredRole === 'support' &&
      (user.role === 'supportAdmin' || user.role === 'menuAdmin'));

  if (!hasAccess) {
    return <Redirect to="/not-found" />;
  }

  return <>{children}</>;
};

SupportRoleGuard.propTypes = {
  children: PropTypes.node.isRequired,
  requiredRole: PropTypes.string,
};

export default SupportRoleGuard;
